import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import SeoHead from '../../components/feature/SeoHead';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';

const jsonLd = {
  '@context': 'https://schema.org',
  '@type': 'Service',
  name: 'Desguace en Sant Andreu de la Barca – Compra de Coches',
  description: 'Compramos coches en Sant Andreu de la Barca al mejor precio. Siniestrados, averiados, sin ITV. Recogida gratuita y pago inmediato.',
  provider: {
    '@type': 'AutoDealer',
    name: 'Desguace Barcelona',
    telephone: '+34932932913',
    address: { '@type': 'PostalAddress', addressLocality: 'Sant Andreu de la Barca', addressRegion: 'Cataluña', addressCountry: 'ES' },
  },
  areaServed: { '@type': 'City', name: 'Sant Andreu de la Barca' },
  url: `${siteUrl}/desguace-sant-andreu-barca`,
};

export default function DesguaceSantAndreuBarcaPage() {
  return (
    <div className="min-h-screen bg-white">
      <SeoHead
        title="Desguace en Sant Andreu de la Barca | Mejor Precio | Recogida Gratis"
        description="Desguace en Sant Andreu de la Barca. Compramos coches siniestrados, averiados o sin ITV al mejor precio. Recogida gratuita en Sant Andreu de la Barca. Pago inmediato."
        keywords="desguace Sant Andreu Barca, vender coche Sant Andreu de la Barca, compra coches Sant Andreu, desguace Baix Llobregat"
        canonical={`${siteUrl}/desguace-sant-andreu-barca`}
        jsonLd={jsonLd}
      />
      <Navbar />

      <div className="pt-32 pb-20 bg-gradient-to-br from-[#f8f9fa] to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h1 className="text-5xl font-bold text-[#1a2332] mb-6 leading-tight">
              Desguace en Sant Andreu de la Barca
            </h1>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
              Compramos tu coche en Sant Andreu de la Barca al mejor precio. Servicio rápido,
              profesional y con recogida gratuita en cualquier zona de la ciudad.
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 mb-20">
            <div className="bg-white rounded-2xl shadow-lg p-8 border border-gray-100">
              <div className="flex items-center mb-6">
                <div className="w-12 h-12 bg-[#ff6b35] rounded-lg flex items-center justify-center mr-4">
                  <i className="ri-map-pin-line text-white text-2xl"></i>
                </div>
                <h2 className="text-2xl font-bold text-[#1a2332]">
                  Zonas de Sant Andreu de la Barca
                </h2>
              </div>
              <ul className="space-y-3">
                {[
                  'Sant Andreu Centro',
                  'El Palau',
                  'Can Salvatella',
                  'Les Planes',
                  'Can Claramunt',
                  'Zona Industrial',
                  'El Serral',
                  'La Solana',
                ].map((zone) => (
                  <li key={zone} className="flex items-center text-gray-700">
                    <i className="ri-checkbox-circle-fill text-[#ff6b35] mr-3"></i>
                    {zone}
                  </li>
                ))}
              </ul>
            </div>

            <div className="bg-white rounded-2xl shadow-lg p-8 border border-gray-100">
              <div className="flex items-center mb-6">
                <div className="w-12 h-12 bg-[#ff6b35] rounded-lg flex items-center justify-center mr-4">
                  <i className="ri-star-line text-white text-2xl"></i>
                </div>
                <h2 className="text-2xl font-bold text-[#1a2332]">
                  Ventajas en Sant Andreu de la Barca
                </h2>
              </div>
              <ul className="space-y-4">
                {[
                  'Recogida gratuita en todo Sant Andreu de la Barca',
                  'Tasación inmediata por WhatsApp o teléfono',
                  'Pago al instante en efectivo o transferencia',
                  'Gestión completa de toda la documentación',
                  'Servicio en 24-48h desde tu llamada',
                  'Sin compromiso - Tasación gratuita',
                ].map((item, idx) => (
                  <li key={idx} className="flex items-start">
                    <i className="ri-check-line text-[#ff6b35] text-xl mr-3 mt-1"></i>
                    <span className="text-gray-700">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div className="bg-gradient-to-r from-[#ff6b35] to-[#ff8c5a] rounded-2xl shadow-xl p-12 text-center mb-20">
            <h2 className="text-3xl font-bold text-white mb-4">
              ¿Tienes un coche en Sant Andreu de la Barca que quieres vender?
            </h2>
            <p className="text-white/90 text-lg mb-8 max-w-2xl mx-auto">
              Contacta ahora y recibe una tasación gratuita en minutos. Compramos todo tipo de vehículos
              en cualquier estado.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
              <a
                href="https://wa.me/34932932913?text=Hola%20Desguaces%20Barcelona%2C%20quiero%20vender%20mi%20coche%20en%20Sant%20Andreu%20de%20la%20Barca"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-[#25D366] text-white px-8 py-4 rounded-full text-lg font-semibold hover:bg-[#1da851] transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer inline-flex items-center"
              >
                <i className="ri-whatsapp-line mr-2 text-xl"></i>
                WhatsApp: 932 932 913
              </a>
              <a
                href="tel:+34932932913"
                className="bg-white text-[#ff6b35] px-8 py-4 rounded-full text-lg font-semibold hover:bg-gray-50 transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer inline-flex items-center"
              >
                <i className="ri-phone-line mr-2 text-xl"></i>
                Llamar Ahora
              </a>
            </div>
          </div>

          <div className="bg-white rounded-2xl shadow-lg p-8 border border-gray-100">
            <h2 className="text-3xl font-bold text-[#1a2332] mb-8 text-center">
              Tipos de Coches que Compramos en Sant Andreu de la Barca
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {[
                { icon: 'ri-car-line', title: 'Coches Siniestrados', desc: 'Accidentes, golpes, daños estructurales' },
                { icon: 'ri-tools-line', title: 'Coches Averiados', desc: 'Problemas mecánicos, motor, transmisión' },
                { icon: 'ri-file-warning-line', title: 'Coches Sin ITV', desc: 'ITV caducada, no pasa inspección' },
                { icon: 'ri-time-line', title: 'Coches Antiguos', desc: 'Vehículos de más de 15 años' },
                { icon: 'ri-fire-line', title: 'Coches Quemados', desc: 'Daños por fuego o incendio' },
                { icon: 'ri-water-flash-line', title: 'Coches Inundados', desc: 'Daños por agua o inundación' },
              ].map((item) => (
                <div key={item.title} className="flex items-start p-4 bg-[#f8f9fa] rounded-lg">
                  <i className={`${item.icon} text-[#ff6b35] text-2xl mr-3 mt-1`}></i>
                  <div>
                    <h3 className="font-semibold text-[#1a2332] mb-1">{item.title}</h3>
                    <p className="text-sm text-gray-600">{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}
